import { useQuery } from "@tanstack/react-query";
import { useAuth } from "react-oidc-context";

const fetchProfile = async (token) => {
  const response = await fetch(`/api/profile`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return response.json();
};

export const useProfile = () => {
  const auth = useAuth();
  return useQuery({
    queryKey: ["profile"],
    queryFn: async () => fetchProfile(auth.user?.access_token),
    staleTime: 60000, // Keep the data fresh for 1 minute
    refetchOnWindowFocus: false, // Disable refetching on window focus
    enabled: !!auth.user,
  });
};
